/* eslint-disable */
import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify';
import SelectField from '../selectField';

// helpers
import { getDomainNames } from '../../helpers/general'
import { makeSendActivationEmailDTO } from './sendActivationEmail.helpers';

import { resendActivationEmail, sendActivationEmail } from '../../services/user';
import styles from './sendActivationEmail.module.scss'
import { useTranslation } from 'react-i18next';

const SendActivationEmail = ({ showModal, handleClose, userId, userEmail, userStatus }) => {
  const [domainName, setDomainName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const setAsSubmitted = () => setIsSubmitting(false);
  const { t } = useTranslation()
  
  const handleSendActivationEmailSuccess = () => {
    toast.success(t('send-activation-sent-successfully'))
    handleClose();
  };

  const handleSendActivationEmailFailure = (err) => {
    toast.error(err.message)
  };

  const handleSendActivationEmail = () => {
    const sendActivationEmailDTO = makeSendActivationEmailDTO(domainName);
    setIsSubmitting(true)
    if (userStatus === 'PROVISIONED') {
      resendActivationEmail(sendActivationEmailDTO, userId)
        .then(handleSendActivationEmailSuccess)
        .catch(handleSendActivationEmailFailure)
        .finally(setAsSubmitted);
    } else {
      sendActivationEmail(sendActivationEmailDTO, userId)
        .then(handleSendActivationEmailSuccess)
        .catch(handleSendActivationEmailFailure)
        .finally(setAsSubmitted);
    }
  };

  const handleDomainNameChange = (event) => {
    event?.stopPropagation();
    const { value } = event?.target || {};
    setDomainName(value);
  };

  return (
    <Dialog open={showModal} onClose={handleClose} onClick={(e) => e.stopPropagation()}>
      <DialogTitle className={styles.heading}>
        {t('send-activation-title')}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          className={styles.iconBtn}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={styles.container}>
        <div className={styles.msg}>
          {`${t('send-activation-email-will-send-to')} ${userEmail}`}<br />
          {t('send-activation-continue')}
        </div>
        <SelectField
          options={getDomainNames()}
          label={t('send-activation-option-label')}
          id="domainName"
          value={domainName}
          error=""
          onChange={handleDomainNameChange}
        />
      </DialogContent>
      <DialogActions className={styles.actions}>
        <Button
          onClick={handleClose}
          type="submit"
          className={styles.cancelBtn}
          variant="contained"
          disabled={isSubmitting}
        >
          {t('reset-password-cancel')}
        </Button>
        <Button
          onClick={handleSendActivationEmail}
          type="submit"
          className={styles.continueBtn}
          variant="contained"
          disabled={isSubmitting || !domainName}
        >
          {t('reset-password-continue-to-send')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SendActivationEmail;
